module.exports = __webpack_public_path__ + "img/click.40d7e57c.png";